import AuthHeader from "@/features/auth/components/AuthHeader"
import ForgotPasswordBox from "@/features/auth/resetPassword/components/ForgotPasswordBox"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import AuthPageLayout from "@/features/platform-layout/components/AuthPageLayout"
import { LoadingOverlay } from "@/features/shared/components/Loaders"
import { useEffect } from "react"
import { useForgotPassword } from "../hooks/useForgotPassword"
const ForgotPassword = () => {

    const { onBackButtonClick, handleInputSubmit, isLoading, emailErrorText } = useForgotPassword()
    const { sendEvent } = useCreateEvent()

    useEffect(() => {
        void sendEvent({
            event: EventType.PAGE_VIEW,
            sub_category: "forgot_password_page",
        })
    }, [])

    // ********************************************************************************

    return (
        <AuthPageLayout>
            <AuthHeader
                onBackClick={onBackButtonClick}
            />
            <div className="w-full flex-1 flex flex-col items-center justify-center mt-[80px] overflow-hidden ">
                <div className="w-full sm:w-[328px] md:w-[400px] lg:w-[500px] p-[20px] bg-white">
                    <ForgotPasswordBox
                        onSubmit={handleInputSubmit}
                        emailErrorText={emailErrorText}
                    />
                </div>
            </div>
            {
                isLoading && <LoadingOverlay />
            }
        </AuthPageLayout>
    )
}

export default ForgotPassword
